    const formBusqueda = document.getElementById("form-busqueda");
    const formFactura = document.getElementById("form-factura");
    const pedidoDetalle = document.getElementById("pedido-detalle");
    const btnFile = document.getElementById("btn-file");
    const fileInput = document.getElementById('archivo-csf');
    const btnName = document.getElementById('btn-name');
    let orderId = null; // se usará al guardar datos fiscales

    const validarRFC = (rfc) => /^[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}$/i.test(rfc);
    const validarCP = (cp) => /^[0-9]{5}$/.test(cp);

    const mostrarError = (msg) => {
      notyf.error(msg);
    };

    const mostrarMensaje = (msg) => {
      notyf.success(msg);
    };

function toggleLoader(button, loading = true) {
  const loader = button.querySelector(".loader");
  const text = button.querySelector(".text");
  if (loading) {
    loader.classList.remove("hidden");
    text.textContent = "Cargando...";
    button.disabled = true;
  } else {
    loader.classList.add("hidden");
    text.textContent = button.id === "btn-buscar" ? "Buscar pedido" : "Enviar datos de facturación";
    button.disabled = false;
  }
}

function convertirArchivoABase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(",")[1]; // Elimina encabezado data:application/pdf;base64,
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

btnFile.addEventListener("click", () => {
    fileInput.click();
});

fileInput.addEventListener('change', () => {
    if (fileInput.files.length > 0) {
      btnName.textContent = fileInput.files[0].name;
    } else {
      btnName.textContent = "Ningún archivo seleccionado";
    }
});

formBusqueda.addEventListener("submit", async (e) => {
  e.preventDefault();
  formFactura.reset();
  fileInput.value = "";
  btnName.textContent = "Ningún archivo seleccionado";
  formFactura.classList.add("hidden");
  pedidoDetalle.classList.add("hidden");

  const orderNumber = document.getElementById("order-number").value.trim();
  const email = document.getElementById("email").value.trim();
  const btn = document.getElementById("btn-buscar");

  if (!orderNumber || !email) {
    mostrarError("Debes llenar todos los campos.");
    return;
  }

  toggleLoader(btn, true);

  try {
    const res = await fetch("https://2nis9reodg.execute-api.us-east-2.amazonaws.com/default/BillingShopify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ order_number: orderNumber, email, action:'verificar-pedido' })
    });

    const data = await res.json();

    if (!res.ok) {
      mostrarError(data.error || "No se encontró el pedido.");
      return;
    }

    orderId = data.order_id;

    pedidoDetalle.classList.remove("hidden");
    pedidoDetalle.innerHTML = `
      <h3>Pedido ${data.name}</h3>
      <div class="pedido-info">
      <p>Total: $${data.total_price}</p>
      <ul>${data.line_items.map(item => `<li>${item.quantity} × ${item.name}</li>`).join("")}</ul>
      </div>
    `;

    formFactura.classList.remove("hidden");
    mostrarMensaje("Pedido encontrado. Ingresa tus datos fiscales.");

    // Aquí prellenamos los campos si existen datos en billing:
    const billing = data.billing || {};

    document.getElementById("rfc").value = billing.rfc || "";
    document.getElementById("razon-social").value = billing.razon_social || "";
    document.getElementById("uso-cfdi").value = billing.uso_cfdi || "";
    document.getElementById("regimen-fiscal").value = billing.regimen_fiscal || "";
    document.getElementById("cp").value = billing.cp || "";
    document.getElementById("metodo-pago").value = billing.metodo_pago || "";
  } catch (err) {
    console.log(err);
    mostrarError("Error al verificar pedido.");
  } finally {
    toggleLoader(btn, false);
  }
});

formFactura.addEventListener("submit", async (e) => {
  e.preventDefault();

  const form = e.target;
  if (!form.checkValidity()) {
    mostrarError("Completa todos los campos requeridos correctamente.");
    return;
  }

  const btn = document.getElementById("btn-enviar-factura");
  const rfc = document.getElementById("rfc").value.trim().toUpperCase();
  const razonSocial = document.getElementById("razon-social").value.trim();
  const usoCfdi = document.getElementById("uso-cfdi").value;
  const regimenFiscal = document.getElementById("regimen-fiscal").value;
  const cp = document.getElementById("cp").value.trim();
  const metodoPago = document.getElementById("metodo-pago").value;
  const archivo = fileInput.files[0];

  if (!validarRFC(rfc)) return mostrarError("RFC no es válido.");
  if (!validarCP(cp)) return mostrarError("Código postal no válido.");
  if (!archivo || archivo.type !== "application/pdf") return mostrarError("Debes subir un archivo PDF válido.");

  toggleLoader(btn, true);

  try {
    const base64Archivo = await convertirArchivoABase64(archivo);

    const res = await fetch("https://2nis9reodg.execute-api.us-east-2.amazonaws.com/default/BillingShopify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        order_id: orderId,
        action: 'guardar-datos-factura',
        datos_fiscales: {
          rfc,
          razon_social: razonSocial,
          uso_cfdi: usoCfdi,
          regimen_fiscal: regimenFiscal,
          metodo_pago: metodoPago,
          cp,
          archivo_nombre: archivo.name,
          archivo_base64: base64Archivo
        }
      })
    });

    const data = await res.json();

    if (!res.ok) {
      mostrarError(data.error || "No se pudo guardar la factura.");
      return;
    }

    mostrarMensaje("¡Datos fiscales y archivo guardados correctamente!");

    formFactura.reset();
    fileInput.value = "";
    btnName.textContent = "Ningún archivo seleccionado";
    formFactura.classList.add("hidden");
    pedidoDetalle.classList.add("hidden");
  } catch (err) {
    console.log(err);
    mostrarError("Error al guardar la factura.");
  } finally {
    toggleLoader(btn, false);
  }
});